import axios from "axios";
import configTable from "../../models/configTable/configTable";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getColums() {
    let token = localStorage.getItem("token");
    let operId = localStorage.getItem("operId");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/operlayouts/${operId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return configTable.fromJson(item);
        })
      );
  }

  getColumsTableName(tabla) {
    let token = localStorage.getItem("token");
    let operId = parseInt(localStorage.getItem("operId"), 10);
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/operlayouts/${operId}/tabla/${tabla}`, { headers })
      .then(({ data }) => data);
  }

  addTableColums(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      operId: data.operId,
      tabla: data.nameTable,
      jsonData: data.json,
    };

    return axios
      .post(`${url}/operlayouts`, payload, { headers })
      .then(({ data }) => data);
  }
}

export default service;
